import React, { Component } from "react";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";


class DatePickerItem extends Component{

    state ={
        mode: 'year'
    }

    render(){
        const dateFormat = this.props.dateFormat ? this.props.dateFormat : 'DD/MM/YYYY'
        return(
            <DatePicker
            {...this.props}
            style={{ width: '100%' }}
            mode={this.state.mode}
            locale={locale}
            format={dateFormat}
            onPanelChange={(value, mode) => this.setState({ mode: mode })}
            inputReadOnly
          />
        )
    }
}


export default DatePickerItem